.ItemAmountContainer
    height: 40px
    gap: 4px
    padding: 0 6px
    .AmountInput, .AmountButton
        width: 27px
        height: 27px
    .Disabled
        background: rgb($globalSettingsBackgroundPrimary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
        &:hover
            background: rgb($globalSettingsBackgroundPrimary)
    .Divider
        height: 40px
        width: 1px
        background: rgb($globalSettingsStrokeSecondary)
    .TextButtonContainer
        height: 100%
        padding-left: 5px
        padding-right: 15px
        font-size: 14px
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        flex-grow: 1
        box-sizing: border-box
        border-radius: $globalButtonRounding
    .TextButtonActive
        cursor: pointer
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
            transition: background 0s
    .TextButtonNotAvailable
        background: rgb($globalSettingsBackgroundTertiary)
        border: 0px
        display: flex
        flex-direction: row
        gap: 10px
        padding: 15px
        stroke: rgb($globalSettingsFontSecondary)
        span
            flex-grow: 1
            text-align: center
